import { useAuth } from '@on3/ui-lib/index';
import { classYearClaimCutoff } from '@on3/ui-lib/utils/constants';
import clsx from 'clsx';
import useAthlete from 'contexts/AthleteProvider';

import { AthleteClaimButton } from '../AthleteClaimButton';
import styles from './AthleteClaimBanner.module.scss';

interface ClaimProfileProps {
  className?: string;
}

export const AthleteClaimBanner = ({ className }: ClaimProfileProps) => {
  const { athlete, hasBaseProfile } = useAthlete();
  const { user } = useAuth();

  if (
    athlete.athleteVerified ||
    user?.pk ||
    !hasBaseProfile ||
    athlete.classYear < classYearClaimCutoff
  ) {
    return null;
  }

  return (
    <div className={clsx(styles.block, className)}>
      <div className={styles.card}>
        <h2>Are you {athlete.name}, or a parent/guardian of?</h2>
        <p>
          Claim your profile and boost your exposure with schools and college
          coaches
        </p>
        <AthleteClaimButton buttonText="Claim and Manage Profile" />
      </div>
    </div>
  );
};
